import FeaturedIntro from './featured-intro';

export default FeaturedIntro;
